import React, { useEffect, useState } from 'react';
import { Constants } from '../../Utils/Constants';

function isValidJson(jsonString) {
  try {
    jsonString = JSON.parse(jsonString);
    if (typeof jsonString !== 'object')
      return false;
    return true;
  } catch (error) {
    return false;
  }
}

const PanCheck = ({user}) => {
  const [panNumber, setPanNumber] = useState('');
  const [panInfo, setPanInfo] = useState(null);
  const [selectedOption, setSelectedOption] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setPanNumber(e.target.value);
  };
  const handleSubmit = () => {
    if(!panNumber){
      alert("Please enter the PAN Number.");
      return false;
    }
    if(!selectedOption){
      alert("Please enter the call selection.");
      return false;
    }
    setIsLoading(true);
    let url = "";
    if(selectedOption == 1){
      //call the advance api
      url = Constants.COMMON_BACKEND_URL+"api/pan-check-advance";
    }else{
      //call the advance plus api
      url = Constants.COMMON_BACKEND_URL+"api/pan-check-advanceplus";
    }
    const raw = JSON.stringify({
      type: "text",
      pan: panNumber,
      key: "FPMbEqThW1odE3t6w9zC$&FJ@PHRxfPL"
    });
    const requestOptions = {
      method: "POST",
      body: raw,
      redirect: "follow",
      headers: {
        "Content-Type": "application/json"
      }
    };
    fetch(url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result,result.responseStatus);
        if (Object.keys(result).length > 0) {
          console.log(result);
          setPanInfo(result);
        }else{
          setPanInfo({});
        }
      })
      .catch((error) => console.error(error)).finally(() => {
        // Set loading to false after the request is complete
        setIsLoading(false);
      });;
  };
  const renderPanInfoAdvance = () => {
    if (!panInfo) return null;
    if (!panInfo.responseData.data.data || !panInfo.responseData.data) {
      return <p>No PAN information found.</p>;
    }
    let formattedData = {};
    const { data, status } = panInfo.responseData.data;
    if(selectedOption == 1){
       formattedData = {
        aadhaar_seeding_status : 'Aadhaar Pan Status',
        category : 'Category',
        first_name : 'First Name',
        full_name : 'Full Name',
        last_name : 'Last Name',
        last_updated : 'Last Updated',
        name : 'Name',
        pan_number : 'PAN Number',
        pan_status_code : 'PAN Status'
      };
    }else{
       formattedData = {
        aadhaar : 'Aadhaar No',
        aadhaar_linked_status : 'Aadhar – Pan Status',
        address : 'Address',
        city : 'City',
        country : 'Country',
        dob : 'DOB',
        email : 'E-mail',
        first_name : 'First Name',
        gender : 'Gender',
        last_name: 'Last Name',
        middle_name:'Middle Name',
        mobile_no:'Mobile No',
        pan:'PAN',
        pincode:'Pincode',
        state:'State'
      };
    }
    
    return (
      <div>
      <h2>PAN Information</h2>
      <div>
      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
      <tbody>
        {Object.entries(data).map(([key, value]) => {
          const formattedKey = formattedData[key]; // Get the formatted key from formattedData, or use the original key if not found
          if(!formattedKey) return null;
          console.log("Key:", key, "Value:", value);
          if(selectedOption == 1){
            if(key == 'aadhaar_seeding_status'){
              value = (value == true) ? "Linked" : "Not Linked";
            }else if(key == 'pan_status_code'){
              value = (value == 'E') ? "Existing and Valid" : "Existing and Not Valid";
            }
          }else{
            if(key == 'aadhaar_linked_status'){
              value = (value == true) ? "True- Linked" : "False- Not Linked";
            }else if(key == 'pan_status_code'){
              value = (value == 'E') ? "Existing and Valid" : "Existing and Not Valid";
            }
          }
          return (
            <tr key={key}>
              <td style={{ border: '1px solid black', padding: '5px', borderRadius: '5px', }}>
                <strong style={{  padding: '4px', }}>
                  {formattedKey}:
                </strong>
              </td>
              <td style={{ border: '1px solid black', padding: '5px', borderRadius: '5px', }}>
                {value}
              </td>
            </tr>
          );
        })}
         </tbody>
    </table>
      </div>
    </div>
    );
  };

  return (
    <>
  {/* ["11166","15220","15470"].includes(user.employee_code) ?    */}
 <div className="container">
      <div className="row">
        <div className="col">
          <div className="row mrg-t30">
            <div className="col-lg-12">
              <h2>Pan Information</h2>
              <div>
                <input
                  type="radio"
                  value={1}
                  checked={selectedOption === 1}
                  onChange={() => {setSelectedOption(1);setPanInfo('')}}
                />
                <label htmlFor="option1">&nbsp;Validate Name</label>&nbsp;
                <br/>
                <input
                  type="radio"
                  value={2}
                  checked={selectedOption === 2}
                  onChange={() => {setSelectedOption(2);setPanInfo('')}}
                />
                <label htmlFor="option2">&nbsp;Validate DOB</label>
              </div>
            </div>
            <div className="col-lg-4 mrg-t30">
              <input
                className="searchbar"
                type="text"
                placeholder="Enter the Pan Number"
                value={panNumber}
                onChange={handleChange}
              />
              <input
              style={{
                marginLeft: '10px',
              }}
                className="btn btn-outline-primary"
                type="button"
                value="Submit"
                onClick={handleSubmit}
              />
              {isLoading && <div>Loading...</div>} 
            </div>
            <div className="row">
            <div className="col-lg-12">
              {renderPanInfoAdvance()}
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    {/* :
 <div className="container">
      <div className="row">
        <div className="col">
          <div className="row mrg-t30">
            <div className="col-lg-12">
              <h2>Access not provided</h2>
            </div>
            </div>
            </div>
            </div>
            </div> */}
            </>
  );
};

export default PanCheck;
